import { ReactComponent as StatusSuccessSVG } from '../assets/images/status-success.svg';

const StatusSuccess = () => {
  return <StatusSuccessSVG className="text-cta-green" />;
}

export default StatusSuccess;
